import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'productAttribute',
    pure: true
})
export class BDCPProductAttributePipe implements PipeTransform {

    // tslint:disable-next-line:max-line-length
    public transform(productAttribute: 'ONSITE_3_YEARS' | 'PRINT_AIRBAG_1MIO' | 'PRINT_AIRBAG_750k' | 'PRINT_AIRBAG_400k' | 'PRINT_AIRBAG_350k' | 'PRINT_AIRBAG_200k' | 'PRINT_AIRBAG_150k' | 'PRINT_AIRBAG_100k' | 'PRINT_AIRBAG_15k'): string {
        return `assets/images/${productAttribute}.jpg`;
    }

}
